/* eslint-disable no-console, no-redeclare, class-methods-use-this */
/* global VK, gtag, App, ym, fbq, ttq, _tmr, ga */

class Analytics {
  constructor() {
    this.events = [];
    this.path = null;
    this.ymTracker = App.production ? 46196496 : 62176867;
    this.gtagId = App.production ? 'G-W84WW532M8' : 'G-CVNPDCN58W';

    if (App.development) {
      console.log(`analtyics constructor boot up, ym ${this.ymTracker}`);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.pageview());
    } else {
      this.pageview();
    }
  }

  flushCallbacks = () => {
    App.analyticsCallbacks?.forEach((callback) => callback());
    App.analyticsCallbacks = [];
  };

  pageview = (path) => {
    // path можно передать вручную, когда URL в браузере не меняется
    this.path = path || window.location.pathname;
    this.url = path ? `${window.location.origin}${path}` : window.location.href;

    if (App.development) {
      console.log('analytics DOMContentLoaded pageview');
    }

    setTimeout(() => {
      if (typeof VK !== 'undefined') {
        VK.Retargeting.Hit();
      }
    });

    if (typeof gtag !== 'undefined') {
      if (App.development) {
        console.log('gtag pageview', this.path);
      }

      // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
      gtag('config', this.gtagId, { page_path: this.path });
      gtag('event', 'page_view', { send_to: 'metrics' });
    }

    if (typeof ym !== 'undefined') {
      if (App.development) {
        console.log(`ym pageview ${this.path}`);
      }

      ym(this.ymTracker, 'hit', this.path);
    }

    if (typeof fbq !== 'undefined') {
      if (App.development) {
        console.log('fbq track PageView');
      }

      fbq('track', 'PageView');
    }

    if (typeof ttq !== 'undefined') {
      if (App.development) {
        console.log('ttq track PageView');
      }

      ttq.page();
    }

    // https://top.mail.ru/help/ru/code/ajax
    if (typeof _tmr !== 'undefined') {
      _tmr.push({
        id: '3546051', type: 'pageview', url: this.url, referrer: document.referrer,
      });
      // VK Ads pixel — учёт SPA-переходов (базовый pageView шлётся из shared/_vk_ads_pixel)
      _tmr.push({
        id: '3771343', type: 'pageview', url: this.url, referrer: document.referrer,
      });
    }

    this.flushEvents();

    if (App.analyticsCallbacks) {
      this.flushCallbacks();
    }
  };

  event = (name, value) => {
    if (App.development) {
      console.log(`analytics event ${name} value ${JSON.stringify(value)}`);
    }

    if (this.path !== null) {
      if (typeof VK !== 'undefined') {
        VK.Retargeting.Event(name);
      }

      if (typeof gtag !== 'undefined') {
        switch (name) {
          case 'Lead':
            gtag('event', 'generate_lead');
            break;
          case 'CompleteRegistration':
            gtag('event', 'sign_up');
            break;
          case 'Purchase':
            gtag('event', 'purchase', { value, currency: 'RUB' });
            break;
          default:
            gtag('event', name, { send_to: 'metrics' });
            break;
        }
      }

      if (typeof fbq !== 'undefined') {
        if (App.development) {
          console.log('fbq track', name);
        }

        fbq('track', name);
      }

      if (typeof ym !== 'undefined') {
        if (App.development) {
          console.log(`ym event ${name}`);
        }

        ym(this.ymTracker, 'reachGoal', name);
      }
    } else {
      this.events.push({ name, value });
    }
  };

  flushEvents = () => {
    if (App.development) {
      console.log('analytics flush events');
    }

    this.events.forEach((evt) => this.event(evt.name, evt.value));
    this.events = [];

    if (App.pixelEvents) {
      this.flushPixelEvents();
    }
  };

  flushPixelEvents = () => {
    if (App.development) {
      console.log('analytics flush pixel events');
    }

    Object.entries(App.pixelEvents).forEach(([name, value]) => {
      if (App.development) {
        console.log(`processing pixel event ${name} / ${value} (${typeof (value)})`);
      }

      const price = typeof (value) === 'undefined' ? 3150 : parseInt(value);

      if (typeof VK !== 'undefined') {
        VK.Retargeting.Event(name);
      }

      if (typeof ym !== 'undefined') {
        let opts = {};

        if (name === 'Purchase') {
          opts = { order_price: price, currency: 'RUB' };
        }

        if (App.development) {
          console.log(`ym tracker event ${name}`, opts);
        }

        ym(this.ymTracker, 'reachGoal', name, opts);
      }

      if (typeof fbq !== 'undefined') {
        let opts = {};

        if (name === 'Purchase') {
          opts = { value: price, currency: 'RUB' };
        }

        if (App.development) {
          console.log(`fbq tracker event ${name}`, opts);
        }

        fbq('track', name, opts);
      }

      if (typeof ga !== 'undefined') {
        ga('send', 'event', {
          eventCategory: 'GAPixel',
          eventAction: name,
          eventValue: name === 'Purchase' ? price : 0,
        });
      }
    });

    App.pixelEvents = [];
  };

  telegramEvent = (eventName) => {
    if (App.development) {
      console.log('analytics telegram event', eventName);

      return;
    }

    const localStorageKey = `telegram-event-${eventName}`;

    if (localStorage.getItem(localStorageKey)) {
      return;
    }

    window.tgp?.('event', eventName);

    // Чтобы не отправлять событие много раз,
    // сохраняем в localStorage, что событие было отправлено
    localStorage.setItem(localStorageKey, '1');
  };
}

window.App = window.App || {};
window.App.analytics = new Analytics();
